import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Row, Col } from 'reactstrap';
import GridHeader from '../../components/common/GridHeader';
import Files from 'react-files';
import ActionsRenderer from './DocumentsGridActionsRenderer';
import DocumentTypes from '../common/LookupDropDown';
import DocumentModal from './DocumentModal';
import { DataGrid } from '@mui/x-data-grid';
import { apiGet } from '../../utils/Api';
import fileDownload from 'js-file-download';

const Documents = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [documentType, setDocumentType] = useState(null);
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [showAddFiles, setShowAddFiles] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState({});

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleToggleAddFiles = () => {
        setShowAddFiles(!showAddFiles);
    };

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleDelete = () => {
        props.onDelete(deleteConfirmationState.toDelete.map(x => props.getEntityId(x)));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    const handleAddFiles = (files) => {
        props.onAddFiles(documentType || props.documentTypes[0].lookupId, files);
        setShowAddFiles(false);
    };

    const handleTypeChange = (e) => {
        setDocumentType(parseInt(e.currentTarget.value, 10));
    };

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                //need to switch here if its programData or trainingData
                toDelete: props.data.filter(x => e.find(y => y === props.getEntityId(x)))

            });
            setDeleteEnabled(true);
        } else {
            setDeleteEnabled(false);
        }
    };

    const getDeletedItems = () => {
        return deleteConfirmationState.toDelete.map((x) => (
            <li key={x.documentId || x.id || x.fileName}>{x.fileName}</li>
        ));
    };


    const handleToggleDocumentModal = () => {
        setShowDocumentModal(!showDocumentModal);
    };

    const handleSelect = (e) => {
        setSelectedDocument({
            selectedEntityId: props.getEntityId(e.row),
            documentTypeId: e.row.documentTypeId,
        });
        handleToggleDocumentModal();
    };

    const handleSave = (documentTypeId) => {
        props.onSave(selectedDocument.selectedEntityId, documentTypeId);
    };

    const handleDownloadClick = (id) => {
        apiGet(`${process.env.REACT_APP_API_HOST}api/document/${id}/url`)
            .then(doc => {
                fetch(doc.url,
                    {
                        method: 'GET',
                        credentials: 'include',
                    })
                    .then(res => {
                        res.blob().then(blob => fileDownload(blob, doc.fileName, doc.contentType));
                    });
            });
    };

    const columns = [
        {
            headerName: 'Document Type',
            field: 'type',
            flex: 3,
        },
        {
            headerName: 'Created Date',
            field: 'createdDate',
            flex: 3,
        },
        {
            headerName: 'File Name',
            field: 'fileName',
            flex: 3,
        },
        {
            headerName: 'Added By',
            field: 'addedBy',
            flex: 3,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            renderCell: (params) => (
                <ActionsRenderer
                    context={params}
                    handleDownloadClick={() => handleDownloadClick(params.row.documentId)}
                    handleDeleteClick={handleDeleteClick}
                />
            ),
        },
    ];

    return (
        <>
            <Modal isOpen={deleteConfirmationState.display}>
                <ModalHeader toggle={handleDeleteConfirmationToggle}>Delete Documents</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete the following document(s)?
                    <ul>{getDeletedItems()}</ul>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleDelete}>
                        Ok
                    </Button>{" "}
                    <Button color="secondary" onClick={handleDeleteConfirmationToggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Row className="mb-1">
                <GridHeader
                    gridEntities="Documents"
                    deleteButtonId="deleteDocumentButton"
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId="addDocumentButton"
                    onAddClick={handleToggleAddFiles}
                    addTooltipTarget={"addDocumentButton"}
                    deleteTooltipTarget={"deleteDocumentButton"}
                    tooltipEntity={"Document"}
                />
            </Row>
            <Row className="mb-1">
                <Col>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGrid
                            rows={(props.data || []).map(x => { return { id: props.getEntityId(x), ...x } })}
                            columns={columns}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            pageSize={25}
                            disableSelectionOnClick
                            getRowClassName={(params) => 'grid-row'}
                            sx={{
                                backgroundColor: 'white'
                            }}
                        />
                    </div>
                </Col>
            </Row>
            <DocumentModal
                entityId={selectedDocument.selectedEntityId}
                documentTypeId={selectedDocument.documentTypeId}
                documentTypes={props.documentTypes}
                onSave={handleSave}
                isOpen={showDocumentModal}
                onToggle={handleToggleDocumentModal}
            />
            <Modal isOpen={showAddFiles}>
                <ModalHeader toggle={handleToggleAddFiles}>{props.title}</ModalHeader>
                <ModalBody>
                    <div className="files">
                        <DocumentTypes
                            label={"Add as Document Type"}
                            name={"documentTypeId"}
                            value={documentType}
                            lookups={props.documentTypes}
                            onChange={handleTypeChange}
                        />
                        <Files
                            className="files-dropzone"
                            onChange={handleAddFiles}
                            //   onError={onFilesError}
                            // accepts={['image/png', '.pdf', 'audio/*']}
                            multiple
                            maxFileSize={10000000}
                            minFileSize={0}
                            clickable
                        >
                            <label>Drop files here or click to upload</label>
                        </Files>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleToggleAddFiles}>
                        Close
                    </Button>{" "}
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Documents;